import moment from 'moment';
import { memo } from 'react';

import { isFutureDate } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { messages } from './NetSuiteExchangeRateDisclaimer.messages';
import { Root } from './NetSuiteExchangeRateDisclaimer.styles';
import { NetSuiteExchangeRateDisclaimerProps } from './NetSuiteExchangeRateDisclaimer.types';

export const NetSuiteExchangeRateDisclaimer = memo<NetSuiteExchangeRateDisclaimerProps>((props) => {
    const { isManualRate, date, defaultCurrency, selectedCurrency, exchangeRate } = props;

    if (exchangeRate === null || (isManualRate && !selectedCurrency)) {
        return null;
    }

    return (
        <Root>
            {isManualRate
                ? messages.manualRate({
                      defaultCurrency,
                      selectedCurrency,
                      exchangeRate,
                  })
                : messages.autoRate({
                      date: <b>{isFutureDate(date) ? moment.utc().format('ll') : moment.utc(date).format('ll')}</b>,
                      exchangeRate: <b>{exchangeRate}</b>,
                  })}
        </Root>
    );
});

NetSuiteExchangeRateDisclaimer.displayName = 'NetSuiteExchangeRateDisclaimer';
